import React from 'react';

import ProcessTaskSchemaEditor from 'processes/settings/ProcessTaskSchemaEditor';

export default function CreateProcessTaskSchemaPage(): JSX.Element {
  return <ProcessTaskSchemaEditor schemaId={null} />;
}
